import React from "react";
import { useMutation } from "react-query";
import { DEFAULT_PER_PAGE } from "../../../../helpers/default";
import ContentBlock from "../../../../components/Layout/ContentBlock";
import FilterMenu from "../../../../components/Layout/FilterMenu";
import {
  ButtonSecondary,
  Pagination,
  TextInput,
} from "../../../../components/globals";
import TableFilterBox from "../../../../components/common/TableFilterBox";
import {
  ButtonDelete,
  ButtonEditRow,
} from "../../../../components/common/Buttons";
import {
  antdAsyncMessageError,
  antdAsyncMessageSuccess,
} from "../../../../helpers/AsyncMessage";
import { Modal } from "antd";
import { useModal } from "../../../../hooks";
import { InputSwitchComponent } from "../../../../components/globals";
import { IconXmlFeedGenerationBanner } from "../../../../components/Layout/Icons";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useQuery } from "react-query";
import axios from "axios";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import XMLFeedGenerationTabUi from "./XMLFeedGenerationTabUi";
import ContentValidation from "../../../../components/common/ContentValidation";
import { FaPlus, FaMinus } from "react-icons/fa";
import ModalSetting from "./modals/ModalSetting";


dayjs.extend(isBetween);

const { confirm } = Modal;

const AdditionalSettings = ({ tabId, setTabId }) => {
  const [page, setPage] = React.useState(1);
  const [perPage, setPerPage] = React.useState(DEFAULT_PER_PAGE);
  const [totals, setTotals] = React.useState(0);
  const [filterTitle, setFilterTitle] = React.useState("");
  const [filterValue, setFilterValue] = React.useState("");
  const [filterStatus, setFilterStatus] = React.useState("");

  const { modalOpt, setModalOpt, closeModal } = useModal();

  const fetchFeedSettings = async () => {
    let url = `/api/v1/feed_settings?`;
    if (filterTitle) {
      url += `&q[title_i_cont]=${filterTitle}`;
    }
    if (filterValue) {
      url += `&q[value_i_cont]=${filterValue}`;
    }
    if (filterStatus === "true") {
      url += `&q[active_true]=true`;
    }
    if (filterStatus === "false") {
      url += `&q[active_false]=true`;
    }
    const response = await axios.get(url);
    return response.data;
  };

  const {
    data: feedSettings,
    isLoading: feedSettingsLoading,
    error: feedSettingsError,
    refetch: refetchBanners,
  } = useQuery("feed_settings", fetchFeedSettings);

  const handleFilterChange = () => {
    refetchBanners();
  };

  const deleteBannerMutation = useMutation(
    (id) => axios.delete(`/api/v1/feed_settings/${id}`),
    {
      onSuccess: () => {
        antdAsyncMessageSuccess({
          text: "Successfully deleted",
          key: "delete_banner",
        });
        refetchBanners();
      },
      onError: () => {
        antdAsyncMessageError({
          text: "Error occurred",
          key: "delete_banner",
        });
      },
    }
  );

  const handleFilterClear = () => {
    setFilterTitle("");
    setFilterValue("");
    setFilterStatus("");
  };

  React.useEffect(() => {
    if (feedSettings?.total) {
      setTotals(feedSettings?.total);
    }
  }, [feedSettings]);

  React.useEffect(() => {
    refetchBanners();
  }, [modalOpt]);

  return (
    <>
      <ContentBlock>
        <FilterMenu
          length={feedSettings?.data?.length}
          text2={`XML feeds`}
          iconComponent={<IconXmlFeedGenerationBanner />}
          onChangeCountPage={setPerPage}
          countPage={perPage}
          page={page}
          totals={feedSettings?.data?.totals}
        />
      </ContentBlock>
      <div className="col-12">
        <XMLFeedGenerationTabUi tabId={tabId} setTabId={setTabId} />
      </div>
      <ContentBlock>
        <TableFilterBox
          filter={true}
          onFilter={() => {
            handleFilterChange();
          }}
          add={false}
          clearFilter={() => handleFilterClear()}
          button1={
            <>
              <div className="float-left ml-2" style={{ width: 104 }}>
                <ButtonSecondary
                  onClick={() => setModalOpt("new_setting", 0)}
                >
                  New setting
                </ButtonSecondary>
              </div>
            </>
          }
        >
          <div className="d-flex justify-content-between flex-1 flex-wrap">
            <div className="d-flex flex-wrap">
              <>
                <div className="px-1">
                  <TextInput
                    text="Title"
                    name="Title"
                    value={filterTitle}
                    onChange={(val) => {
                      setFilterTitle(val.target.value);
                    }}
                  />
                </div>
                <div className="px-1">
                  <TextInput
                    text="Value"
                    name="value"
                    value={filterValue}
                    onChange={(val) => {
                      setFilterValue(val.target.value);
                    }}
                  />
                </div>
                {/* <div className="px-1">
                  <InputSwitchComponent
                    label="Status"
                    name="auto_type"
                    options={[
                      {
                        label: "All",
                        value: "",
                      },
                      {
                        label: "Active",
                        value: "true",
                      },
                      {
                        label: "Inactive",
                        value: "false",
                      },
                    ]}
                    value={filterStatus}
                    onChange={(val) => {
                      setFilterStatus(val.target.value);
                    }}
                  />
                </div> */}
              </>
            </div>
          </div>
        </TableFilterBox>
        <div>
          <div className="table-responsive" style={{ overflow: "hidden" }}>
            <ContentValidation
              loader={feedSettingsLoading}
              array={feedSettings?.data}
              error={feedSettingsError}
            >
              <table className="table mt-3">
                <thead>
                  <tr className="text-muted">
                    <th className="text-black">Title</th>
                    <th className="text-black">Code</th>
                    <th className="text-black">Value</th>
                    <th className="text-black">Date</th>
                    <th className="text-black">Category</th>
                    <th className="text-black">
                      Product
                    </th>
                    <th className="text-black">Brand</th>
                    <th className="text-black"></th>
                  </tr>
                </thead>
                <tbody>
                  {feedSettings?.data?.map?.((item) => (
                    <tr className="align-middle tableColumn" key={item.id}>
                      <td className="align-middle">{item?.title}</td>
                      <td className="align-middle">{item?.code}</td>
                      <td className="align-middle">{item?.value}</td>
                      <td className="align-middle">{item?.valid_from} - {item?.valid_to}</td>
                      <td className="align-middle">
                        <div className="feed-tablet-container">
                          {item.included_category_ids?.length > 0 && (
                            <div className="feed-tablet-plus">
                              <FaPlus color="#03B0F7" />
                              <p style={{ margin: 0, marginLeft: 5 }}>
                                {item.included_category_ids.length}{" "}
                                {item.included_category_ids.length === 1 ? "category" : "categories"}
                              </p>
                            </div>
                          )}
                          {item.excluded_category_ids?.length > 0 && (
                            <div className="feed-tablet-minus">
                              <FaMinus color="#E61D01" />
                              <p style={{ margin: 0, marginLeft: 5 }}>
                                {item.excluded_category_ids.length}{" "}
                                {item.excluded_category_ids.length === 1 ? "category" : "categories"}
                              </p>
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="align-middle">
                        <div className="feed-tablet-container">
                          {item.included_product_ids?.length > 0 && (
                            <div className="feed-tablet-plus">
                              <FaPlus color="#03B0F7" />
                              <p style={{ margin: 0, marginLeft: 5 }}>
                                {item.included_product_ids.length}{" "}
                                {item.included_product_ids.length === 1 ? "product" : "products"}
                              </p>
                            </div>
                          )}
                          {item.excluded_product_ids?.length > 0 && (
                            <div className="feed-tablet-minus">
                              <FaMinus color="#E61D01" />
                              <p style={{ margin: 0, marginLeft: 5 }}>
                                {item.excluded_product_ids.length}{" "}
                                {item.excluded_product_ids.length === 1 ? "product" : "products"}
                              </p>
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="align-middle">
                        <div className="feed-tablet-container">
                          {item.included_brand_ids?.length > 0 && (
                            <div className="feed-tablet-plus">
                              <FaPlus color="#03B0F7" />
                              <p style={{ margin: 0, marginLeft: 5 }}>
                                {item.included_brand_ids.length}{" "}
                                {item.included_brand_ids.length === 1 ? "brand" : "brands"}
                              </p>
                            </div>
                          )}
                          {item.excluded_brand_ids?.length > 0 && (
                            <div className="feed-tablet-minus">
                              <FaMinus color="#E61D01" />
                              <p style={{ margin: 0, marginLeft: 5 }}>
                                {item.excluded_brand_ids.length}{" "}
                                {item.excluded_brand_ids.length === 1 ? "brand" : "brands"}
                              </p>
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="align-middle">
                        <div className="d-flex justify-content-end gap-5">
                          <ButtonEditRow
                            className="d-flex justify-content-center align-items-center"
                            onClick={() =>
                              setModalOpt("edit_setting", item.id)
                            }
                          />
                          <ButtonDelete
                            className="d-flex justify-content-center align-items-center"
                            onDelete={() =>
                              confirm({
                                title: "Are you sure?",
                                icon: (
                                  <ExclamationCircleOutlined className="text-primary" />
                                ),
                                content:
                                  "You will not be able to undo this action",
                                onOk() {
                                  deleteBannerMutation.mutate(item.id);
                                },
                                onCancel() {
                                  console.log("Cancel");
                                },
                              })
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </ContentValidation>
            <Pagination
              setPagination={setPage}
              page={page}
              totals={totals}
              pageCount={perPage}
            />
          </div>
        </div>
        {modalOpt.type === "new_setting" && (
          <ModalSetting
            onClose={closeModal}
            modalOpt={modalOpt}
          />
        )}
        {modalOpt.type === "edit_setting" && (
          <ModalSetting
            onClose={closeModal}
            modalOpt={modalOpt}
            feedSettingsData={feedSettings?.data}
          />
        )}
      </ContentBlock>
    </>
  );
};

export default AdditionalSettings;
